import { render } from "./HomeSection.vue?vue&type=template&id=16d0a640"
import script from "./HomeSection.vue?vue&type=script&lang=js"
export * from "./HomeSection.vue?vue&type=script&lang=js"
script.render = render

export default script